import MoleculeStructure from "../../../../components/Data/MoleculeStructure"
import TruncatedText from "../../../../components/Page/TruncatedText"
import { ReadAcrossDataType } from "../../page/IndividualReadAcrossPage"
import { ReactComponent as TargetIcon } from '../../../../assets/Icons/adornments/Target.svg';

const convertNumberToDecimal = (value: number | string) => {
    if (isNaN(Number(value))) {
        return value.toString();
    } else {
        const numValue = Number(value);
        return (Math.round(numValue * 100) / 100 as number).toFixed(2);
    }
}

export default function StructureCell({
    data,
    index,
}: {
    data: ReadAcrossDataType,
    index: number,
}) {
    return (
        <div className="py-4 px-6 flex-col justify-center items-center gap-2">
            <div className="flex justify-center items-center gap-2">
                <p className="font-semibold text-default">{convertNumberToDecimal(data.tanimoto)}</p>
                {index === 0 && <div className="w-[14px] text-quaternary"><TargetIcon /></div>}
            </div>
            <div><MoleculeStructure width={100} height={100} smiles={data.smiles}/></div>
            {data.chemical_name ? (
                <TruncatedText text={data.chemical_name} alignment="center">
                    <p className="max-w-[100px] truncate font-semibold text-default">{data.chemical_name}</p>
                </TruncatedText>
            ) : (
                <p className="opacity-0">No value</p>
            )}
        </div>
    )
}